import { CHAIN_ID } from "@config/constants/networks";
import useAccount from "@hooks/useAccount";
import { simpleRpcProvider } from "@utils/providers";
import type { Address } from "viem";
import { useConfig, usePublicClient, useWalletClient } from "wagmi";
const useActiveWagmi = () => {
	const { account, connector, isConnected, isConnecting, chain } = useAccount();
	const accountAddr = account as Address;
	const { chains } = useConfig();
	const provider = usePublicClient();
	const { data: signer } = useWalletClient();
	const chainId = chain?.id || Number.parseInt(CHAIN_ID(), 10);
	const library = provider || simpleRpcProvider();

	return {
		accountAddr,
		chain,
		chainId,
		chains,
		connector,
		isConnected,
		isConnecting,
		library,
		signer: signer,
	};
};

export default useActiveWagmi;
